<div class="dialog-header">
  <div class="header-title"><span style="font-size: 120%;">{{dialogHeader}}</span></div>
  <div class="buttons-block" *ngIf="showSendButton">

    <button class="open-source-button" mat-button (click)="openPdfInNewTab()">
      <span>Browser View</span>
    </button>
  </div>

  <button mat-button class="close-button-container" [mat-dialog-close]="true" disableRipple="true">
    <mat-icon>clear</mat-icon>
  </button>
</div>

<div class="middle-content">
  <div class="pdf-block">
    <div class="spinner-block" *ngIf="showLoadingSpinner">
      <lib-progress-spinner></lib-progress-spinner>
    </div>


    <ngx-extended-pdf-viewer [src]="blobUrl"
                             [enablePinchOnMobile]="true"
                             [zoom]="'page-actual'"
                             [showPresentationModeButton]="false"
                             [handTool]="false"
                             [showBookmarkButton]="false"
                             [minZoom]="0.8"
                             [showOpenFileButton]="false">
    </ngx-extended-pdf-viewer>

  </div>

  <div class="proposals-block">

    <div class="proposals-list">
      <div class="proposal header-labels">
        <div class="header-label header-name">
          Name
        </div>
        <!--        <div class="header-label header-discount">-->
        <!--          Discount-->
        <!--        </div>-->
      </div>
      <div class="proposal" *ngFor="let proposal of proposals" (click)="openDropbox(proposal)">
        <div class="proposal-title" matRipple>{{proposal.name}}</div>
        <div class="proposal-icon" (click)="chooseProposalName(proposal, $event)" matRipple>
          <i class="pi pi-copy"></i>
        </div>
      </div>
    </div>
    <div class="space-block"></div>
    <div class="proposal-tool">
      <div class="regenerate-block">
        <input class="arrow-input" type="number" pInputText BlockLateralArrowNavigation
               [ngModelOptions]="{standalone: true}" placeholder="Discount %" [(ngModel)]="discountPercent1">
        <div class="additional-discount">
          <div class="add-discount-input">
            <input class="arrow-input" type="text" pInputText BlockLateralArrowNavigation
                   [ngModelOptions]="{standalone: true}" placeholder="Additional Discount Title"
                   [(ngModel)]="discountPercent2Title">
          </div>
          <div class="add-discount-input percent-input">
            <input class="arrow-input" type="number" pInputText BlockLateralArrowNavigation
                   [ngModelOptions]="{standalone: true}" placeholder="%"
                   [(ngModel)]="discountPercent2">
          </div>
        </div>
        <button mat-button class="regenerate-button" [disabled]="!discountPercent1 && !discountPercent2"
                [ngClass]="{'disabled-button': !discountPercent1 && !discountPercent2}" (click)="regenerate()">Regenerate
        </button>
      </div>
      <input class="name-input" type="text" pInputText BlockLateralArrowNavigation
             [ngModelOptions]="{standalone: true}" placeholder="File Name" [(ngModel)]="newFileName">
      <button mat-button class="create-button" (click)="saveProposal()">Save Proposal
      </button>
    </div>
  </div>
</div>

<p-confirmDialog appendTo="body" icon="pi pi-pencil" styleClass="replace-panel">
</p-confirmDialog>
